import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

const MACHINES_REVIEW_QUEUE_MIN_PAGE_SIZE = 10;
const MACHINES_REVIEW_QUEUE_DEFAULT_PAGE_SIZE = 10;

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/machines/review-queue",
)({
    validateSearch: (search: Record<string, unknown>) => ({
        offset: typeof search.offset === "number" ? Math.max(0, search.offset) : 0,
        limit:
            typeof search.limit === "number"
                ? Math.max(MACHINES_REVIEW_QUEUE_MIN_PAGE_SIZE, search.limit)
                : MACHINES_REVIEW_QUEUE_DEFAULT_PAGE_SIZE,
    }),
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
